













































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';

import { RobotOption, TwitterCardOption } from '@/models/MetaTags';
import { getLocalesString } from '@/models/Locale';
import { BusyList, BusyObject } from '@/models/Busy';
import { AddressesService, Package, PackagesService, Product, ProductsService, AccountAddress, Subscription, SubscriptionsService, PayPalSubscriptionApproval, PayPalSubscription, Account, AccountsService } from '@/api/braendz';
import { AccountInfo } from '@azure/msal-browser';
import LoadingView from '@/components/Spinner/LoadingView.vue';
import PayPalSubscribeButtons from '@/components/Checkout/PayPalSubscribeButtons.vue';
import TermsPopup from '@/components/Popups/TermsPopup.vue';

import ProductCardStarter from '@/components/Products/ProductCardStarter.vue';
import ProductCardProfessional from '@/components/Products/ProductCardProfessional.vue';
import ProductCardEnterprise from '@/components/Products/ProductCardEnterprise.vue';
import ProductCardProfessionalPromo1 from '@/components/Products/ProductCardProfessionalPromo1.vue';

@Component({
    components: {
        LoadingView,
        PayPalSubscribeButtons,
        TermsPopup,
        ProductCardStarter,
        ProductCardProfessional,
        ProductCardProfessionalPromo1,
        ProductCardEnterprise
    },
    metaInfo() {
        return {
            title: this.$i18n.t("subscribe.title").toString(),
            meta: [
                { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') }
            ]
        };
    }
})
export default class Subscribe extends Vue {

    // Member:
    public step = 1;
    public termsVisible = false;

    public product = new BusyObject<Product>();

    public packages = new BusyList<Package>();
    public selectedPackages: Package[] = [];

    public billingAddress = new BusyObject<AccountAddress>({});
    public billingAddressValid = false;

    public updatedAccount = new BusyObject<Account>();

    public termsAgreed = false;
    public withdrawalAgreed = false;
    public marketingAgreed = false;
    public isBusinessAccount = false;

    public activatedSubscription = new BusyObject<Subscription>();

    public result: 'Succeeded' | 'ErrorPayPal' | 'ErrorBraendz' | 'Cancelled' | 'UnexpectedState' | null = null;
    public payPalError: string | null = null;

    // Parameters:
    @Prop({ required: true })
    public productKey!: string

    @Prop({ required: false, default: 1 })
    public initialStep!: number;

    @Prop({ required: false, type: Array, default: () => [] })
    public packageKeys!: string[];

    // Getter & Setter:
    public get userAccount(): AccountInfo | null {
        return this.$store.state.userAccount;
    }

    public get planId(): string | null {
        return this.product.object?.payPalPlanId ?? null;
    }

    public get activeSubscription(): BusyObject<Subscription> {
        return this.$store.state.activeSubscription;
    }

    public get account(): BusyObject<Account> {
        return this.$store.state.account;
    }

    public get activePayPalSubscription(): PayPalSubscription | null | undefined {
        return this.activeSubscription.object?.payPalSubscription;
    }

    public get numberOfMissingPackages(): number | null {
        if (this.product.object?.includedPackages) {
            return this.product.object.includedPackages - this.selectedPackages.length;
        }
        return null;
    }

    public get isSubscriptionUpdate() {
        const payPalSubscriptionId = this.activeSubscription.object?.payPalSubscription?.id;
        const payPalSubscriptionStatus = this.activeSubscription.object?.payPalSubscription?.status;

        return !!payPalSubscriptionId && (payPalSubscriptionStatus === 'ACTIVE' || payPalSubscriptionId === 'SUSPENDED');
    }

    public get recommendationEuropeanUnionActive() {
        return this.selectedPackages.find(pgk => pgk.key === 'germany' || pgk.key === 'austria' || pgk.key === 'france' || pgk.key === 'spain')
            && !this.selectedPackages.find(pgk => pgk.key === 'europe');
    }

    // Watchers:
    @Watch('step')
    public onStepChange(newStep: number, oldStep: number) {
        if (newStep !== oldStep) {
            this.updateQueryParameterStep(newStep);
        }
    }

    @Watch('selectedPackages')
    public onSelectedPackagesChange(newPackages: Package[], oldPackages: Package[]) {
        if (newPackages !== oldPackages) {
            this.updateQueryParameterPackages(newPackages);
        }
    }

    // Lifecycle Methods:
    public mounted() {
        // Initialize the selected product:
        this.initProduct();

        // Initialize packages:
        this.initPackages();

        // Initialize billing address:
        this.initBillingAddress();

        // Set the initial step:
        this.initStep();
    }

    // Stepper Methods
    public finishStepProductSelection() {
        this.step = 2;
    }

    public async finishStepBillingAddress() {
        if(this.isBusinessAccount) {
            await this.upsertBillingAddress();
        }
        this.step = 3;
    }

    public async finishStepPayment() {
        this.step = 4;
    }

    public restart() {
        this.step = 1;
        this.payPalError = null;
        this.result = null;
        this.isBusinessAccount = false;
        this.termsAgreed = false;
        this.withdrawalAgreed = false;
        this.marketingAgreed = false;
    }

    // Payment State Handling:
    public onPaymentCancelled(data: any) {
        this.result = 'Cancelled';
        this.finishStepPayment();
    }

    public onPaymentFailed(error: any) {
        this.payPalError = error;
        this.result = 'ErrorPayPal';
        this.finishStepPayment();
    }

    public onActivationFailed() {
        this.result = 'ErrorBraendz';
        this.finishStepPayment();
    }

    public onSucceeded() {

        if (this.activatedSubscription.object?.state === 'Active') {
            this.result = 'Succeeded';
        }
        else {
            this.result = 'UnexpectedState';
        }

        this.finishStepPayment();
    }

    // Processing Methods
    public initStep() {
        this.step = this.initialStep;
    }

    public async initProduct() {
        await this.loadProduct(this.productKey);
    }

    public async initPackages() {
        const packages = await this.packages.load(async () => {
            return (await PackagesService.getPackages(false));
        });
        this.selectedPackages = (packages ?? []).filter(pkg => this.packageKeys.includes(pkg.key));
    }

    public async initBillingAddress() {
        if (this.userAccount) {
            await this.getBillingAddress();
        }
    }

    public async loadProduct(productKey?: string | null) {
        if(!productKey) this.product.reset();
        else await this.product.load(async () => {
            return await ProductsService.getProduct(productKey, false);
        });
    }

    public async refreshActivatedSubscription() {
        await this.activatedSubscription.load(async () => {
            if (this.activatedSubscription.object?.id) {
                return SubscriptionsService.getSubscription(this.activatedSubscription.object.id)
            }
            else {
                return SubscriptionsService.getActiveSubscriptionCurrentUserDefaultAccount();
            }
        });

        if (this.step === 4) {
            if (this.activatedSubscription.object?.state === 'Active') {
                this.result = 'Succeeded';
            }
            else {
                this.result = 'UnexpectedState';
            }
        }
    }

    public isPackageSelectionDisabled(pkg: Package): boolean {
        if (this.selectedPackages.includes(pkg)) {
            return false;
        }
        else if (!(this.product.object?.includedPackages)) {
            return true;
        }
        else if (this.product.object.includedPackages - this.selectedPackages.length <= 0) {
            return true;
        }
        else {
            return false;
        }
    }

    public async getBillingAddress() {
        await this.billingAddress.load(async () => {
            const result = await AddressesService.getBillingAddressCurrentUserDefaultAccount();
            return result ?? {};
        });
    }

    public async upsertBillingAddress() {
        await this.billingAddress.update(async () => {
            if (this.billingAddress.object) {
                return await AddressesService.upsertBillingAddressCurrentUserDefaultAccount(this.billingAddress.object);
            }
            else {
                return null;
            }
        });
    }

    public async updateAccount() {
        await this.updatedAccount.update(async () => {
            const currentAccount = this.account.object;

            if(!currentAccount || !currentAccount.id) {
                throw new Error("Account object is not available.");
            }

            // Update the user account with the new billing address:
            currentAccount.type = this.isBusinessAccount ? 'Business' : 'Consumer';
            currentAccount.agreedTermsUtc = this.termsAgreed ? new Date().toISOString() : null;
            currentAccount.agreedWithdrawalUtc = this.withdrawalAgreed ? new Date().toISOString() : null;
            currentAccount.agreedMarketingUtc = this.marketingAgreed ? new Date().toISOString() : null;

            // Update the user account in the backend:
            const updatedAccount = await AccountsService.updateAccount(currentAccount.id, currentAccount);

            // Update the user account in the store:
            this.$store.commit('setAccount', updatedAccount);

            return updatedAccount;
        });
    }

    public async createSubscription(payPalSubscriptionId: string, planId: string): Promise<void> {
        try {
            await this.updateAccount();
            await this.activatedSubscription.create(async () => {
                return await SubscriptionsService.createPayPalSubscriptionCurrentUserDefaultAccount({
                    payPalSubscriptionId: payPalSubscriptionId,
                    payPalPlanId: planId,
                    packageKeys: this.selectedPackages.map(i => i.key)
                });
            });

            if (this.activatedSubscription.object) {
                this.updateVuexActiveSubscription(this.activatedSubscription.object);
            }

            this.onSucceeded();
        } catch {
            this.onActivationFailed();
        }
    }

    public async updateSubscription(payPalSubscriptionId: string, planId: string): Promise<void> {
        try {
            await this.updateAccount();
            await this.activatedSubscription.update(async () => {
                return await SubscriptionsService.updatePayPalSubscription(payPalSubscriptionId, {
                    payPalPlanId: planId,
                    packageKeys: this.selectedPackages.map(i => i.key)
                });
            });

            if (this.activatedSubscription.object) {
                this.updateVuexActiveSubscription(this.activatedSubscription.object);
            }

            this.onSucceeded();
        } catch {
            this.onActivationFailed();
        }
    }

    public updateVuexActiveSubscription(activeSubscription: Subscription) {
        this.$store.commit('setActiveSubscription', activeSubscription);
    }

    // State Handling
    public updateQueryParameterStep(step?: number) {
        const routerStep = this.$route.query.step;
        if (step?.toString() === routerStep) return;

        if (!step || isNaN(step) || step < 1) {
            const query = { ...this.$route.query };
            delete query.step;
            this.$router.replace({ query });
        }
        else {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    step: step.toString()
                }
            });
        }
    }

    public updateQueryParameterPackages(packages?: Package[]) {
        const packageKeys = packages?.map(p => p.key) ?? [];
        const routerPackageKeys = Array.isArray(this.$route.query.packages) ? this.$route.query.packages as string[]
            : this.$route.query.packages ? [this.$route.query.packages] : [];
    

        if(packageKeys.length === 0 && routerPackageKeys.length === 0) {
            // If no packages are selected and no router package keys are present, do nothing.
            return;
        }

        if(!packageKeys.find(p => !routerPackageKeys.includes(p)) &&
           !routerPackageKeys.find(p => !packageKeys.includes(p))) {
            // If the selected packages and router package keys are the same, do nothing.
            return;
        }

        // The parameter packages should be updated.
        if (!packages || packages.length === 0) {
            const query = { ...this.$route.query };
            delete query.packages;
            this.$router.replace({ query });
        }
        else {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    packages: packages.map(p => p.key)
                }
            });
        }
    }
}
